<template>
  <div>
    <main class="main">
      <!-- <index-carousels></index-carousels> -->
      <div class="container">
        <section
          class="category-section top-category bg-grey mt-10 pt-10 pb-10"
        >
          <div class="container pb-2">
            <h2 class="title justify-content-center pt-1 ls-normal mb-5">
              {{ $shezhi.indexcategorytitle }}
            </h2>
            <div class="d-md-show">
              <div class="swiper-theme pg-show">
                <div class="d-flex hangscroll">
                  <div
                    class="category category-classic category-absolute overlay-zoom br-xs"
                    v-for="(item, index) in leixings"
                    :key="index"
                    style="width: 200px; flex-shrink: 0; padding: 10px"
                  >
                    <router-link
                      :to="{
                        path: '/boutiques',
                        query: {
                          ukey: item.ukey,
                        },
                      }"
                      class="category-media"
                    >
                      <img
                        :src="item.tupian || $store.state.image_moren"
                        alt=""
                        width="130"
                        height="130"
                      />
                    </router-link>
                    <div class="category-content">
                      <h4 class="category-name">
                        {{ duoyuyan(item) }}
                      </h4>
                      <router-link
                        :to="{
                          path: '/boutiques',
                          query: {
                            ukey: item.ukey,
                          },
                        }"
                        class="btn btn-primary btn-link btn-underline"
                      >
                        MiTu
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-md-none">
              <div class="row cols-2">
                <div
                  class="swiper-slide category category-classic category-absolute overlay-zoom br-xs mb-4"
                  v-for="(item, index) in leixings"
                  :key="index"
                >
                  <router-link
                    :to="{
                      path: '/boutiques',
                      query: {
                        ukey: item.ukey,
                      },
                    }"
                    class="category-media"
                  >
                    <img
                      :src="item.tupian || $tupianmoren"
                      alt=""
                      width="130"
                      height="130"
                    />
                  </router-link>
                  <div class="category-content">
                    <h4 class="category-name">
                      {{ duoyuyan(item) }}
                    </h4>
                    <router-link
                      :to="{
                        path: '/boutiques',
                        query: {
                          ukey: item.ukey,
                        },
                      }"
                      class="btn btn-primary btn-link btn-underline"
                    >
                      MiTu
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <icon-box></icon-box>
        <index-show></index-show>
        <!-- <consumer-electronics></consumer-electronics> -->
        <!-- <index-occasion></index-occasion> -->
        <!-- <sale></sale> -->
        <section
          class="vendor-banner-section mb-10 mb-lg-7"
          v-for="(item, index) in gongsi.filter((v) => v.gongsi.length > 0)"
          :key="index"
        >
          <h2 class="title mb-5">{{ duoyuyan(item) }}</h2>
          <div
            class="swiper-container swiper-theme show-code-action"
            data-swiper-options="{
                            'spaceBetween': 20,
                            'slidesPerView': 1,
                            'breakpoints': {
                                '576': {
                                    'slidesPerView': 2
                                },
                                '768': {
                                    'slidesPerView': 3
                                },
                                '992': {
                                    'slidesPerView': 4
                                }
                            }
                        }"
          >
            <div
              class="swiper-wrapper row cols-xl-4 cols-md-3 cols-sm-2 cols-1"
            >
              <div
                class="swiper-slide vendor-widget"
                v-for="(gitem, gindex) in item.gongsi"
                :key="gindex"
              >
                <div class="vendor-widget-banner">
                  <figure class="vendor-banner">
                    <router-link
                      :to="{ path: '/boutique', query: { ukey: gitem.ukey } }"
                    >
                      <img
                        :src="gitem.banner"
                        alt=""
                        width="625"
                        height="300"
                        style="background-color: #40485f"
                      />
                    </router-link>
                  </figure>
                  <div class="vendor-details">
                    <figure class="vendor-logo">
                      <router-link
                        :to="{ path: '/boutique', query: { ukey: gitem.ukey } }"
                      >
                        <img :src="gitem.logo" alt="" width="80" height="80" />
                      </router-link>
                    </figure>
                    <div class="vendor-personal">
                      <h4 class="vendor-name">
                        <router-link
                          :to="{
                            path: '/boutique',
                            query: { ukey: gitem.ukey },
                          }"
                        >
                          {{ duoyuyan(gitem) }}
                        </router-link>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import IconBox from "@/components/IconBox.vue";
import IndexShow from "@/components/IndexShow.vue";
import { getGongSi, getGongSiLeiXing } from "@/api/gongsi";

export default {
  name: "Index",
  components: {
    IconBox,
    IndexShow,
  },
  data() {
    return {
      gongsi: [],
      leixings: [],
    };
  },
  mounted() {
    getGongSiLeiXing().then((data) => {
      if (data.status === "SUCCESSED") this.leixings = data.data;
    });
    this.get_gongsi_http();
  },
  methods: {
    get_gongsi_http() {
      for (let i = 0; i < 10; i += 1) {
        if (this.$shezhimitu["gongsiflag" + (i + 1)] === "on")
          getGongSi({ flag1: i + 1 }).then((data) => {
            if (data.status === "SUCCESSED") {
              this.gongsi.push({
                mingcheng:
                  this.$shezhimitu["gongsiflag" + (i + 1) + "mingcheng"],
                gongsi: data.data,
              });
            }
          });
      }
    },
  },
};
</script>

<style scoped></style>
